/**
 * Class description
 *
 * Created: 2018-07-10
 * @author jonas
 */
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {DungeonQuestSound} from "../DungeonQuestSound";

export class DungeonQuestNormalController extends ReelStopPresentationController {

    constructor(index:number, name:string) {
        super(index, name);
    }

    onReelBounce(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }


    public playReelBouncingSound(data:IReelStoppedData):boolean {

        if(!data.fastSpin && !data.quickStop) {
            SlotGame.sound.playEffect(DungeonQuestSound.instance.REELS_DEFAULT_BOUNCE[data.reelId]);
        } else {
            if(data.reelId == 4) {
                SlotGame.sound.playEffect(DungeonQuestSound.instance.REELS_DEFAULT_BOUNCE[1]);
                SlotGame.sound.playEffect(DungeonQuestSound.instance.REELS_DEFAULT_BOUNCE[3]);
            }
        }

        return true;
    }
}